import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { Waves } from './Waves';
import { heroImage } from '../data/heroImage';
const chips = [{
  label: '6 volumes',
  dot: 'bg-sage'
}, {
  label: '300 pages',
  dot: 'bg-teal'
}, {
  label: '131 Lesson Cards',
  dot: 'bg-peach'
}, {
  label: '3 wind versions per lesson',
  dot: 'bg-sky'
}, {
  label: '5 bonuses',
  dot: 'bg-rose'
}];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'No subscription'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-sky-soft text-navy" data-id="element-116" data-mp="x8b8xs6y3h4y">
      <p aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-4 select-none text-center font-poster text-[26vw] font-bold uppercase leading-none text-white/70 lg:top-6 lg:text-[270px]" data-id="element-117" data-mp="s9q6rn84undv">
        Sailing
      </p>

      <div className="relative mx-auto max-w-6xl px-5 pt-12 sm:pt-16" data-id="element-118" data-mp="382p91mw8pvpw">
        <div className="grid items-center gap-10 lg:grid-cols-[1fr_1fr] lg:gap-12" data-id="element-119" data-mp="384s78u7jqv5p">
          <div data-id="element-120" data-mp="3j9alrqbghebh">
            <p className="text-sm font-bold text-teal-deep" data-id="element-121" data-mp="3j6oe7qokeyt9">
              Sailing Lesson Ready · for sailing instructors and coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] font-bold leading-[1.05] text-navy sm:text-[56px] md:text-[60px]" data-id="element-122" data-mp="399bc1q3avhx1">
              A full season of sailing lessons, planned for every wind.{' '}
              <span className="text-teal" data-id="element-123" data-mp="30h9blrt8e1mr">No more rewriting the plan on the dock.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base text-navy-soft sm:text-lg" data-id="element-124" data-mp="359j8jrsrk1yj">
              Six volumes of ready-to-run lessons for beginners, intermediate
              sailors, race teams, junior camps and adult courses. Every
              Lesson Card comes in three versions with the same learning goal:
              Light Air, Right Air and Wrong Air. Check the wind, open the
              card, teach.
            </p>
            <div className="mt-6 lg:hidden" data-id="element-125" data-mp="2lmv0edfwrwin">
              <CtaButton data-id="element-126" data-mp="s2jj7lrcvge8">Get Sailing Lesson Ready</CtaButton>
              <div className="mt-4 flex justify-center" data-id="element-127" data-mp="s3uqhvk0f6a3">
                <RatingProof tone="light" data-id="element-128" data-mp="najg5kfzo7df" />
              </div>
            </div>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-129" data-mp="ibgmew5glnkr">
              {chips.map(chip => <li key={chip.label} className="flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-navy shadow-sm ring-1 ring-navy/10" data-id="element-130" data-mp="ddnfg0wc0pjf">
                  <span className={`h-2 w-2 rounded-full ${chip.dot}`} data-id="element-131" data-mp="163472wc4o2el" />
                  {chip.label}
                </li>)}
            </ul>
          </div>

          <figure className="mx-auto w-full max-w-xl" data-id="element-132" data-mp="x1nwoolbc0ad">
            <img src={heroImage} alt="The six Sailing Lesson Ready volumes standing on a wooden dock with lesson cards, a whistle and a stopwatch, sailboats on the water behind" className="aspect-[3/2] w-full rounded-3xl object-cover shadow-cover ring-4 ring-white" data-id="element-133" data-mp="x37cke3249bm" />
          </figure>
        </div>

        <div className="mt-10 flex flex-col items-center" data-id="element-134" data-mp="21a4ubxltom71">
          <div className="hidden w-full max-w-md lg:block" data-id="element-135" data-mp="218jzs7zid396">
            <CtaButton data-id="element-136" data-mp="268g1g0kqgilk">Get Sailing Lesson Ready</CtaButton>
          </div>
          <div className="mt-5 hidden lg:block" data-id="element-137" data-mp="2b0zdgt3rv5o9">
            <RatingProof tone="light" data-id="element-138" data-mp="2b2so0jhiaa1j" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-navy-soft" data-id="element-139" data-mp="2fyr65pc8qvti">
            Written for instructors and coaches at sailing schools, yacht
            clubs, community boating centers and summer camps. Dinghies and
            small keelboats, on the water or on shore. One payment, yours to
            keep.
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-navy-muted" data-id="element-140" data-mp="2tysgdveebfln">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-141" data-mp="zkr8ym4s5k9y">
                <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-142" data-mp="4bdxzj5xmfq7" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
      <Waves to="#FFFFFF" className="relative mt-10" data-id="element-143" data-mp="3vh5leasbre9b" />
    </section>;
}